const Icon = ({ label, iconClass, tabIndex = 0, forAttr, onClick, ...rest }) => (
  <label
    className={`desktop-icon ${iconClass}`}
    tabIndex={tabIndex}
    onClick={onClick}
    {...rest}
  >
    <span>{label}</span>
  </label>
);

export default Icon;
